/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Source_Preview_PlaceholderInputs */

const en_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a file from the menu on the left.`)
};

const fr_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez selectionner un fichier dans le menu de gauche.`)
};

const de_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie eine Datei aus dem Menü auf der linken Seite aus.`)
};

const it_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezionare un file dal menu a sinistra.`)
};

const ru_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, выберите файл из меню слева.`)
};

const es_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un archivo del menú de la izquierda.`)
};

const zh_cn2_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请从左侧菜单中选择一个文件。`)
};

const ja_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`左側のメニューからファイルを選択してください。`)
};

const hi_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया बाईं ओर दिए गए मेनू से एक फ़ाइल चुनें।`)
};

const pt_pt2_subtitle_import_source_preview_placeholder = /** @type {(inputs: Subtitle_Import_Source_Preview_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, selecione um arquivo no menu à esquerda.`)
};

/**
* | output |
* | --- |
* | "Please select a file from the menu on the left." |
*
* @param {Subtitle_Import_Source_Preview_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_source_preview_placeholder = /** @type {((inputs?: Subtitle_Import_Source_Preview_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Source_Preview_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "de") return de_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "it") return it_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "ru") return ru_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "es") return es_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "ja") return ja_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "hi") return hi_subtitle_import_source_preview_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_source_preview_placeholder(inputs)
	return en_subtitle_import_source_preview_placeholder(inputs)
});